export default "__VITE_ASSET__f3d43839__"